module.exports = __webpack_public_path__ + "img/vipuser.e2ffd2b4.png";